var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
import { SectorReshapingTool } from './SectorReshapingTool';
var ExtendedSectorReshapingTool = /** @class */ (function (_super) {
    __extends(ExtendedSectorReshapingTool, _super);
    function ExtendedSectorReshapingTool() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If the Part is selected, show two angle-changing tool handles and one radius-changing tool handle.
     * Change Shape color to red when element is locked, otherwise lime.
     * @override
     * @this {SectorReshapingTool}
     * @param {Part} part
     */
    ExtendedSectorReshapingTool.prototype.updateAdornments = function (part) {
        if (part.category !== DiagramConsts.elements.sectorKey) {
            return;
        }
        if (part.isSelected && part.data !== null && this.diagram !== null && !this.diagram.isReadOnly) {
            var ad = part.findAdornment(this.name);
            if (ad === null) {
                var $ = go.GraphObject.make;
                ad =
                    $(go.Adornment, 'Spot', $(go.Placeholder), $(go.Shape, 'Diamond', { width: 10, height: 10 }, new go.Binding('name', '', function (data) { return data.locked ? 'DisabledRADIUS' : 'RADIUS'; }), new go.Binding('fill', '', function (data) { return data.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (data) { return data.locked ? '' : 'move'; }), new go.Binding('alignment', '', function (data) {
                        var angle = SectorReshapingTool.prototype.getAngle(data);
                        var sweep = SectorReshapingTool.prototype.getSweep(data);
                        var p = new go.Point(0.5, 0).rotate(angle + sweep / 2);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })), $(go.Shape, 'Circle', { width: 8, height: 8 }, new go.Binding('name', '', function (data) { return data.locked ? 'DisabledANGLE' : 'ANGLE'; }), new go.Binding('fill', '', function (data) { return data.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (data) { return data.locked ? '' : 'move'; }), new go.Binding('alignment', '', function (data) {
                        var angle = SectorReshapingTool.prototype.getAngle(data);
                        var p = new go.Point(0.5, 0).rotate(angle);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })), $(go.Shape, 'Circle', { width: 8, height: 8 }, new go.Binding('name', '', function (data) { return data.locked ? 'DisabledSWEEP' : 'SWEEP'; }), new go.Binding('fill', '', function (data) { return data.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (data) { return data.locked ? '' : 'move'; }), new go.Binding('alignment', '', function (data) {
                        var angle = SectorReshapingTool.prototype.getAngle(data);
                        var sweep = SectorReshapingTool.prototype.getSweep(data);
                        var p = new go.Point(0.5, 0).rotate(angle + sweep);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })));
                ad.adornedObject = part.locationObject;
                part.addAdornment(this.name, ad);
            }
        }
        else {
            part.removeAdornment(this.name);
        }
    };
    return ExtendedSectorReshapingTool;
}(SectorReshapingTool));
export { ExtendedSectorReshapingTool };
